import styled from 'styled-components';

const Flex = styled.div`
  display: flex;
  align-items: center;
`;

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Container = styled(FlexColumn)`
  border-bottom: 1px solid #f1f1f1;
  margin-bottom: 8px;
  padding-bottom: 8px;
`;

export const SwitchContainer = styled(FlexColumn)`
  padding: 8px;
  gap: 16px;
  width: 284px;
`;

export const SwitchInfoContainer = styled(FlexColumn)`
  flex-direction: row;
  justify-content: space-evenly;
  gap: 8px;
  width: 100%;
`;

export const SwitchInfoItem = styled(FlexColumn)`
  gap: 4px;
  flex: 1;

  h1, p {
    margin: 0;
    font-size: 14px;
    line-height: 19px;
  }

  h1 {
    color: #858585;
    font-family: ProximaNovaRg;
    text-wrap: nowrap;
  }

  p {
    color: #333333;
    font-weight: 700;
  }

  .ant-skeleton,
  .ant-skeleton-input {
    height: 19px;
    border-radius: 4px;
  }
`;

export const CreateButton = styled(Flex)`
  gap: 6px;
  border-radius: 4px;
  padding: 5px 8px;
  cursor: pointer;
  user-select: none;
  border: 1px solid #ededed;
  
  span {
    color: #00AB6B;
    font-size: 14px;
    line-height: 19px;
  }
`;

export const TransferContainer = styled(FlexColumn)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const TransferButton = styled.div`
  bakcground: none;
  border: none;
  display: flex;
  align-items: center;
  padding: 8px;
  height: 35px;
  cursor: pointer;
  gap: 8px;

  :hover {
    background: #F7F7F7;
    border-radius: 4px;
  }
`;
